import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import { Category } from './data.class';

const module = {
  state: {
    categories: Array<Category>()
  },
  mutations: mutations,
  actions: actions,
  getters: getters
};

export default module;
